export const DOCUMENT_MASK = Object.freeze({
  CPF_ONLY: '###.###.###-##',
  CPF_WITH_CNPJ: 'XXX.XXX.XXX-XX',
  CNPJ: 'XX.XXX.XXX/XXXX-XX',
});

const CPF_LENGTH_WITH_MASK = 14;
const CNPJ_LENGTH_WITH_MASK = 18;
export const DOCUMENT_LENGTH_WITH_MASK = Object.freeze({
  CPF: CPF_LENGTH_WITH_MASK,
  CNPJ: CNPJ_LENGTH_WITH_MASK,
});

const CPF_LENGTH_WITHOUT_MASK = 11;
const CNPJ_LENGTH_WITHOUT_MASK = 14;
export const DOCUMENT_LENGTH_WITHOUT_MASK = Object.freeze({
  CPF: CPF_LENGTH_WITHOUT_MASK,
  CNPJ: CNPJ_LENGTH_WITHOUT_MASK,
});

export const CNPJ_NO_VD_LENGTH = 12;
export const CNPJ_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
export const CNPJ_ONLY_ZEROS = '00000000000000';
export const CNPJ_BASE_VALUE = '0'.charCodeAt(0);
export const CPF_MASK_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const CNPJ_MASK_REGEX =
  /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/;
